<template>
  <spec-sub-menu @close="$emit('close')">
    <template #default>
      <div class="header">
        <h1 class="menu-title">Mijn instellingen</h1>
        <button class="pill-button secondary" @click="manage = !manage">
          Beheren
        </button>
      </div>

      <div
        v-for="template in productOrderStore.userPrintTemplates"
        class="template"
        :class="{ manage: manage }"
        :key="template.id"
      >
        <spec-button
          :title="template.template.name"
          @action="$emit('select-template', template)"
          :selected="isTemplateSelected(template)"
          :inactive="!productSecurityCheck(template.template, selectedFiles)"
          :title-attr="templateDisabledReason(template)"
        />
        <button v-if="manage" class="delete" @click="deleteTemplate(template)">
          <inline-svg src="/images/icons/trash.svg"></inline-svg>
        </button>
      </div>
    </template>
  </spec-sub-menu>
</template>

<script>
import { mapStores } from 'pinia'
import { useProductOrderStore } from '@/features/productOrder/ProductOrder.store'
import SpecSubMenu from '@/components/ui/SpecSubMenu.vue'
import SpecButton from '@/components/ui/SpecButton.vue'
import ProductOrderMixin from '@/features/productOrder/ProductOrderMixin'

export default {
  name: 'TemplatesMenu',
  mixins: [ProductOrderMixin],
  components: {
    SpecSubMenu,
    SpecButton
  },
  props: {
    selectedFiles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      manage: false
    }
  },
  computed: {
    ...mapStores(useProductOrderStore)
  },
  methods: {
    // A template carries the securityLevel of its product, so the same
    // secured/regular rule as on the product cards applies (RNJ-1464)
    templateDisabledReason(template) {
      if (this.productSecurityCheck(template.template, this.selectedFiles)) {
        return ''
      }
      return this.productSecurityReason(template.template)
    },
    isTemplateSelected(template) {
      // Return false if no files selected
      if (!this.selectedFiles.length) {
        return false
      }

      // Check if all selected files have the same userTemplate
      const firstFile = this.selectedFiles[0]

      // Check if first file has a userTemplate
      if (!firstFile.productSpecs.userTemplate) {
        return false
      }

      // Check if the template name matches
      if (firstFile.productSpecs.title !== template.template.name) {
        return false
      }

      // Check if all files have the same userTemplate with the same name
      return this.selectedFiles.every(
        (file) =>
          file.productSpecs.userTemplate &&
          file.productSpecs.title === template.template.name
      )
    },
    deleteTemplate(template) {
      this.productOrderStore.deleteUserTemplate(template.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;

  button {
    margin-top: -5px;
    margin-right: -13px;
  }
}

.delete {
  height: 32px;
  width: 32px;
  margin-right: -7px;
}

.template {
  display: flex;
  align-items: center;
  gap: 10px;

  :deep(.spec-button) {
    margin-bottom: 0;
    flex: 0 1 auto;
  }

  svg {
    flex-shrink: 0;
    cursor: pointer;

    :deep(path) {
      transition: fill 0.2s;
    }

    &:hover :deep(path) {
      fill: var(--error-color);
    }
  }
}

.template:not(:last-child) {
  margin-bottom: 10px;
}
.menu-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 15px;
}
</style>
